/**
 * Staging Environment Configuration (Coolify)
 * This file is used when building with --configuration=staging
 */
export const environment = {
  production: false,
  envName: 'staging',

  // Backend API Configuration
  apiUrl: 'https://back.staging.motloud.com/api',
  apiVersion: 'v1',

  // Authentication Configuration (Keycloak OAuth2/OIDC)
  authConfig: {
    issuer: 'https://keycloak.motloud.com/realms/motloud-staging',
    clientId: 'angular-client',
    // Redirect URI will be the frontend URL
    redirectUri: 'https://front.staging.motloud.com/auth/callback',
    // Post logout redirect
    postLogoutRedirectUri: 'https://front.staging.motloud.com',
    scope: 'openid profile email',
    responseType: 'code',
    // Silent refresh
    silentRefreshRedirectUri: 'https://front.staging.motloud.com/silent-refresh.html',
  },

  // Session & Token Configuration
  tokenRefreshInterval: 20 * 60 * 1000, // 20 minutes
  sessionTimeout: 24 * 60 * 60 * 1000, // 24 hours

  // Real-time Data Configuration
  telemetryUpdateInterval: 100, // ms for sensor data updates
  chartUpdateInterval: 1000, // ms for chart updates

  // WebSocket Configuration
  wsUrl: 'wss://back.staging.motloud.com/ws',

  // Feature Flags
  features: {
    enableRealTimeSimulation: true,
    enableAdvancedTelemetry: true,
    enableBetaFeatures: true, // Enabled in staging for testing
    enableDebugMode: true, // Debug enabled in staging
  },

  // Logging Configuration
  logging: {
    level: 'info', // info level in staging
    enableConsoleLogging: true,
    enableRemoteLogging: false,
  },
};
